import type { TMessages } from '@/types/TMessages'

export const messages = {
  sign: '<h5>Услуга в данный момент не оказывается</h5><p>поле.рф готовит обновленный продукт по помощи аграриям по взаимодействию с государственными системами</p>',
} satisfies TMessages
